(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  class GvRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-gv-item]'));
      this.dots = Array.from(this.querySelectorAll('[data-gv-dot]'));
      this.index = 0; this.paused = false;
      if (this.items.length < 2) return;
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      var prev = this.querySelector('[data-gv-prev]'), next = this.querySelector('[data-gv-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });
      var ms = parseInt(this.dataset.interval || '5000', 10);
      if (!reduce && ms > 0) this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index + 1); }, ms);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    go(i) {
      var n = this.items.length;
      this.index = (i + n) % n;
      this.items.forEach((el, k) => {
        var on = k === this.index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        el.querySelectorAll('a, button').forEach((a) => { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
      this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.index); d.setAttribute('aria-current', k === this.index ? 'true' : 'false'); });
      var cur = this.items[this.index];
      if (cur && cur.dataset.light !== undefined) this.setAttribute('data-light', ''); else this.removeAttribute('data-light');
    }
  }
  define('gv-rotator', GvRotator);

  class GvMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gv-track]');
      if (!this.track) return;
      this.paused = false;
      var t = this.track;
      var half = () => t.scrollWidth / 2;
      if (!reduce) {
        this.timer = setInterval(() => {
          if (this.paused || document.hidden) return;
          t.scrollLeft += 1;
          if (t.scrollLeft >= half()) t.scrollLeft -= half();
        }, 20);
      }
      var resumeLater = () => { clearTimeout(this.rt); this.rt = setTimeout(() => { this.paused = false; }, 2500); };
      t.addEventListener('mouseenter', () => { this.paused = true; });
      t.addEventListener('mouseleave', () => { this.drag = null; t.classList.remove('is-dragging'); this.paused = false; });
      t.addEventListener('touchstart', () => { this.paused = true; clearTimeout(this.rt); }, { passive: true });
      t.addEventListener('touchend', resumeLater, { passive: true });
      t.addEventListener('focusin', () => { this.paused = true; });
      t.addEventListener('focusout', () => { this.paused = false; });
      t.addEventListener('dragstart', (e) => e.preventDefault());
      t.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        this.drag = { x: e.clientX, left: t.scrollLeft, moved: false };
        this.paused = true;
        t.classList.add('is-dragging');
      });
      t.addEventListener('mousemove', (e) => {
        var d = this.drag; if (!d) return;
        var dx = e.clientX - d.x;
        if (Math.abs(dx) > 5) d.moved = true;
        var next = d.left - dx, h = half();
        if (next < 0) { next += h; d.left += h; }
        if (next >= h) { next -= h; d.left -= h; }
        t.scrollLeft = next;
      });
      t.addEventListener('mouseup', () => { this.justDragged = this.drag && this.drag.moved; this.drag = null; t.classList.remove('is-dragging'); });
      t.addEventListener('click', (e) => { if (this.justDragged) { e.preventDefault(); e.stopPropagation(); this.justDragged = false; } }, true);
      var step = (dir) => {
        this.paused = true;
        if (dir < 0 && t.scrollLeft < 212) t.scrollLeft += half();
        t.scrollBy({ left: dir * 424, behavior: reduce ? 'auto' : 'smooth' });
        resumeLater();
      };
      var p = this.querySelector('[data-gv-prev]'), n = this.querySelector('[data-gv-next]');
      if (p) p.addEventListener('click', () => step(-1));
      if (n) n.addEventListener('click', () => step(1));
    }
    disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.rt); }
  }
  define('gv-marquee', GvMarquee);

  class GvGallery extends HTMLElement {
    connectedCallback() {
      this.imgs = Array.from(this.querySelectorAll('[data-gv-media]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gv-thumb]'));
      this.thumbs.forEach((b) => b.addEventListener('click', () => this.show(b.dataset.gvThumb)));
    }
    show(id) {
      if (!id) return;
      this.imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.gvMedia === String(id)));
      this.thumbs.forEach((b) => { var on = b.dataset.gvThumb === String(id); b.classList.toggle('is-active', on); b.setAttribute('aria-current', on ? 'true' : 'false'); });
    }
  }
  define('gv-gallery', GvGallery);

  class GvProduct extends HTMLElement {
    connectedCallback() {
      var $ = (s) => this.querySelector(s);
      this.querySelectorAll('input[name="id"][type="radio"]').forEach((r) => r.addEventListener('change', () => this.update(r)));
      var q = $('[data-gv-qty]');
      if (q) {
        this.querySelectorAll('[data-gv-step]').forEach((b) => b.addEventListener('click', () => {
          q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.gvStep, 10));
        }));
      }
      var pinBtn = $('[data-gv-pin-btn]'), pin = $('[data-gv-pin]'), msg = $('[data-gv-pin-msg]');
      if (pinBtn && pin && msg) {
        pinBtn.addEventListener('click', () => {
          var ok = /^[1-9][0-9]{5}$/.test(pin.value.trim());
          msg.textContent = ok ? msg.dataset.ok : msg.dataset.bad;
          msg.style.color = ok ? 'var(--gv-green)' : 'var(--gv-red)';
        });
      }
    }
    update(r) {
      var d = r.dataset, $ = (s) => this.querySelector(s);
      if ($('[data-gv-now]')) $('[data-gv-now]').textContent = d.price;
      var was = $('[data-gv-was]'), off = $('[data-gv-offpct]');
      if (was) { was.textContent = d.compare ? 'MRP ' + d.compare : ''; was.hidden = !d.compare; }
      if (off) { off.textContent = d.off ? d.off + '% off' : ''; off.hidden = !d.off; }
      var btn = $('[data-gv-add]');
      if (btn) { btn.disabled = d.available !== 'true'; btn.textContent = d.available === 'true' ? (btn.dataset.label + ' · ' + d.price) : btn.dataset.soldout; }
      var st = $('[data-gv-stock]'); if (st) st.hidden = d.available !== 'true';
      var so = $('[data-gv-stock-out]'); if (so) so.hidden = d.available === 'true';
      if (d.media) { var g = document.querySelector('gv-gallery'); if (g) g.show(d.media); }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
  }
  define('gv-product', GvProduct);

  class GvFbt extends HTMLElement {
    connectedCallback() {
      this.boxes = Array.from(this.querySelectorAll('input[type="checkbox"][data-id]'));
      this.total = this.querySelector('[data-gv-fbt-total]');
      this.btn = this.querySelector('[data-gv-fbt-add]');
      this.boxes.forEach((b) => b.addEventListener('change', () => this.sum()));
      if (this.btn) this.btn.addEventListener('click', () => this.add());
      this.sum();
    }
    sum() {
      var cents = 0, n = 0;
      this.boxes.forEach((b) => { if (b.checked) { cents += parseInt(b.dataset.price, 10); n++; } });
      if (this.total) this.total.textContent = '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
      if (this.btn) { this.btn.disabled = n === 0; this.btn.textContent = 'Add ' + n + ' to bag'; }
    }
    add() {
      var items = this.boxes.filter((b) => b.checked).map((b) => ({ id: parseInt(b.dataset.id, 10), quantity: 1 }));
      if (!items.length) return;
      this.btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
      }).then(() => { window.location.href = this.dataset.cartUrl || '/cart'; }).catch(() => { this.btn.disabled = false; });
    }
  }
  define('gv-fbt', GvFbt);

  class GvRecs extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      fetch(url).then((r) => r.text()).then((html) => {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('gv-recs');
        if (fresh && fresh.innerHTML.trim()) {
          this.innerHTML = fresh.innerHTML;
          var wrap = this.closest('[data-gv-recs-wrap]'); if (wrap) wrap.hidden = false;
        }
      }).catch(() => {});
    }
  }
  define('gv-recs', GvRecs);
})();